import Players from '@/services/player/Players';
import PresetCommunityCards from '@/services/PresetCommunityCards';
import shareUrlService from '@/services/share-url-service';
import _ from 'lodash';
import storeService from '@/store/service';

let state = {
  hasSimulationBeenRun: false,
  presetCommunityCards: new PresetCommunityCards(),
  players: new Players(),
};

let mutations = {
  setState: function (state, stateFromServer) {
    shareUrlService.setEquityCalculatorStoreState(stateFromServer, state);
  },
  setHasSimulationBeenRun: function (state, value) {
    state.hasSimulationBeenRun = value;
  },

  // player range
  selectGeneralHand: function (state, payload) {
    storeService.selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function (state, payload) {
    storeService.deselectGeneralHand(state, payload);
  },
  selectGeneralHands: function (state, payload) {
    storeService.selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function (state, payload) {
    storeService.deselectGeneralHands(state, payload);
  },
  selectSpecificHand: function (state, payload) {
    storeService.selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function (state, payload) {
    storeService.deselectSpecificHand(state, payload);
  },
  selectSpecificHands: function (state, payload) {
    storeService.selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function (state, payload) {
    storeService.deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function (state, payload) {
    storeService.applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function (state, payload) {
    storeService.applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function (state, payload) {
    storeService.setWeightOfSpecificHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function (state, payload) {
    storeService.setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function (state, payload) {
    storeService.addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function (state, payload) {
    storeService.removeComboFromCombosToAdd(state, payload);
  },
  narrowRange: function (state, payload) {
    state.players.find(payload.playerIndex).narrowRange(
      payload.checkedHands,
      state.presetCommunityCards
    );
  },

  // controls
  setIndividualPresetCommunityCard: function (state, payload) {
    storeService.setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function (state, boardCards) {
    storeService.setBoard(state, boardCards);
  },
  removePresetCommunityCard: function (state, position) {
    storeService.removePresetCommunityCard(state, position);
  },
  addPlayer: function (state, payload) {
    storeService.addPlayer(state, payload);
  },
  removePlayer: function (state, playerIndex) {
    storeService.removePlayer(state, playerIndex);
  },
  updateEquityResults: function (state, payload) {
    let player;
    let equity;
    let wins;
    let ties;
    let winFractions;
    let numberOfSimulations = payload.numberOfSimulations;
    let numPlayers = payload.simulationResults.length;

    for (let i = 0; i < numPlayers; i++) {
      player = state.players.find(i);
      wins = payload.simulationResults[i].wins;
      ties = payload.simulationResults[i].ties;
      winFractions = payload.simulationResults[i].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = ((wins + winFractions) / numberOfSimulations) * 100;
      equity -= (equity * (payload.rakePercentage / 100)) + (equity * (payload.tipPercentage / 100));

      player.states[0].equity = equity;
      player.states[0].winPercentage = (wins / numberOfSimulations) * 100;
      player.states[0].tiePercentage = (ties / numberOfSimulations) * 100;
    }

    state.hasSimulationBeenRun = true;
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
};

export { state, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/equity-calculator/equity-calculator.js